import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { countriesInterface, packagesInterface, Payment_method_interface, ticket_interface } from 'src/core/interfaces/auth.interface';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'app-create-package',
  templateUrl: './create-ticket.component.html',
  styleUrls: ['./create-ticket.component.css']
})
export class CreateTicketComponent implements OnInit , OnDestroy {

  
  form: FormGroup;
  countries: countriesInterface[] = [];
  packages: packagesInterface[] = [];
  payment_methods: Payment_method_interface[] = [];
  is_cash : boolean = false;
  uploaded_file : File;

  
  
  constructor(
    private r : Router,
    private fb: FormBuilder,
    private auth_s: AuthService,
    private cookie_s: CookieService
  ) { }

  ngOnInit(): void 
  {

    // redirect to sign-in when not signed-in
    this.check_if_user_signed_in();
    
    // create form
    this.create_form();

  }


  ngOnDestroy(): void 
  {
    this.form.reset();
  }



  
  
  create_form()
  {
    
    this.form = this.fb.group({
      title : ['' , Validators.required],
      message : ['' , Validators.required]
    });
    
    
  }
  
  




  check_if_user_signed_in()
  {

    let user = this.cookie_s.get('token');

    if ( user )
    {
      // do nothing
    }
    else
    {
      
      // redirect to sign-in page
      this.r.navigate([ 'auth', 'sign-in']);

    }


  }




  
  open_ticket()
  {


    if ( this.form.valid )
    {


      // create api needed data
      let api_data : ticket_interface = {
          title: this.form.value.title,
          replies: {
              message: this.form.value.message,
              reply_type_id: 1   // 1-> for client
          }
      };


      this.auth_s.open_ticket(api_data).subscribe(
        (data : any)=>{
          
          // reset form
          this.form.reset();

          // redirect to sign-in
          this.r.navigate(['auth' , 'account' , 'my-tickets']);
          
        },
        (err)=>{

          alert('⚠️ Failed to open ticket! Please try again later.');
        
        }
      );
      


    }
    else
    {
      alert("Something wrong happened! please try again later.");
    }

  }





}
